import React from "react";

import { useQuery, useApolloClient } from "react-apollo";

import { Dropdown, Icon, Button, Generic } from "rbx";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { CURRENT_USER_QUERY } from "../graphql/Users/Users.graphql";

import { logout } from "./Logout";

function UserActionsDropdown() {
  const { data, loading, error } = useQuery(CURRENT_USER_QUERY);
  const client = useApolloClient();
  if (error) {
    logout(client);
  }
  return (
    <div className="user-actions-dropdown">
      <Dropdown hoverable align="right">
        <Dropdown.Trigger>
          <Button
            outlined
            color="link"
            state={loading || !data?.Me ? "loading" : ""}
          >
            <Icon size="small">
              <FontAwesomeIcon icon="user" />
            </Icon>
            <Generic textColor="white">Hello, {data?.Me?.FirstName}</Generic>
            <Icon size="small">
              <FontAwesomeIcon icon="angle-down" />
            </Icon>
          </Button>
        </Dropdown.Trigger>
        <Dropdown.Menu>
          <Dropdown.Content>
            <Dropdown.Item as="a">Settings</Dropdown.Item>
            <Dropdown.Divider />
            <Dropdown.Item as="a" onClick={() => logout(client)}>
              <Icon>
                <FontAwesomeIcon icon="sign-out-alt" />
              </Icon>
              <span>Logout</span>
            </Dropdown.Item>
          </Dropdown.Content>
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
}

export default UserActionsDropdown;
